export const defaultStyle = {
    mobileNavParentIN:"mobileNavParentIN",
    mobileNavParentINUL:"mobileNavParentINUL",
}